import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

function DistributionChart(props) {

  const colorMap = {
    'BTC' : '#f69c3d',
    'ETH': '#497493',
    'VTC' :'#205b30',
    'DASH': '#1376b5',
    'XMR': '#fc6621',
    'ZEC': '#d38f36',
    'BCC': '#f5922f',
    'BTG': '#e8a629',
     'MTL': '#c5b398',
'MCO' : '#032144',
'OMG': '#2159ec',
'LTC': '#949494',
'XRP': '#1b95ca',
'STRAT' :'#6bb3e0',
'XDN' :'#507ba0',
'NEO' : '#93cb30',
'DMD' :'#a4cad9',
'ZEN': '#f38723',
'USDT': '#2ea07b',
'WCFG': "#efb914",
  };

  const arrayOfArrays = [props?.proportion];
  const allProportions = [];
  const allSymbols = [];

  for (const array of arrayOfArrays) {
    const proportions = array?.map((item, key) => item?.proportion);
    const symbols = array?.map((item) => item?.asset?.symbol);
    allSymbols.push(...symbols); 
    allProportions?.push(proportions);
  }
  const colors = allSymbols.map(asset => colorMap[asset] || '#000');
  const [count, setCount] = useState({
    series: allProportions[0],
    options: {
      dataLabels: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      legend: {
        show: false,
      },
      
      labels: allSymbols, 
      
    },
  });

  return (
    <div id="chart" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      width: '100%'
    }}>
      <ReactApexChart
        options={count.options}
        series={count.series}
        type="pie"
        width={200}
        height={180}
      />
    </div>
  );
}

export default DistributionChart;